import React from "react";
import { View, StyleSheet } from "react-native";
import Text from "@components/CustomText";
import color from "@constants/color";

const ItemCollection = ({
  totalItemCollectionQty,
  totalItemCollectionAmount,
}) => {
  return (
    <View>
      <Text variant="title_16">Item collection</Text>
      <View style={styles.container}>
        <View style={styles.itemContainer}>
          <Text variant="body_text_3" style={styles.label}>
            Total Quantity
          </Text>
          <Text variant="title_16">{totalItemCollectionQty}</Text>
        </View>
        <View style={styles.itemContainer}>
          <Text variant="body_text_3" style={styles.label}>
            Total Quantity amount
          </Text>
          <Text variant="title_16">₹{totalItemCollectionAmount}</Text>
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: color.white,
    padding: 12,
    borderColor: color.lighterBlack,
    borderWidth: 1,
    marginVertical: 12,
    borderRadius: 16,
  },
  itemContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    padding: 8,
    paddingVertical: 4,
    borderRadius: 9,
    alignItems: "center",
  },
  label: {
    color: color.mediumBlacklightBlack,
  },
});

export default ItemCollection;
